<template>
  <div class="remoteConsultation">
    <div class="table-info">
      <div class="breadcrumb">
        <span>位置：</span>
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>菜单管理</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <h3>菜单管理</h3>
    </div>
    <div class="table-content">
      <div class="tool-bar">
        <span>关键字：</span>
        <el-input size="small" placeholder="请输入" width="264" class="key-word" v-model="keywords"></el-input>
        <span>状态：</span>
        <el-select v-model="status"  size="small" class="status">
          <el-option
            v-for="item in statusDatas"
            :key="item.status"
            :label="item.status"
            :value="item.value">
          </el-option>
        </el-select>
        <el-button type="primary" @click="getDataByCondition" size="small" v-if="isCompleted && isShowButton('查询')">查询</el-button>
        <el-button size="small" @click="reset" v-if="isCompleted && isShowButton('重置')">重置</el-button>
        <el-button size="small" type="primary" @click="handleOption('新增')" v-if="isCompleted && isShowButton('新增菜单')">新增菜单</el-button>
      </div>
      <!-- 表格 -->
      <el-table
        :data="SystemManage"
        v-loading="loading"
        style="width: 100%">
       <el-table-column type="expand">
          <template slot-scope="props">
            <el-form label-position="left" inline class="demo-table-expand">
              <el-form-item label="菜单介绍:">
                <span>{{ props.row.contents }}</span>
              </el-form-item>
            </el-form>
          </template>
        </el-table-column>
        <el-table-column
          label="菜单名称"
          prop="menuName" align="center">
        </el-table-column>
        <el-table-column
          label="路径"
          prop="menuUrl" align="center">
        </el-table-column>
        <el-table-column
          label="菜单级别"
          prop="menuLevel" align="center">
        </el-table-column>
        <el-table-column
          label="图标"
          prop="menuIcon" align="center">
        </el-table-column>
        <el-table-column
          label="状态"
          prop="status" align="center">
        </el-table-column>
        <el-table-column
          label="操作"
          width="200px" align="center">
          <template slot-scope="scope">
            <div v-if="scope.row.status === '禁用'">
              <el-button type="text primary" @click="handleOption('编辑',scope.row)">编辑</el-button>
              <el-button type="text primary" @click="operation(scope.row)">启用</el-button>
              <el-popover
                placement="top"
                width="172"
                v-model="scope.row.isAbolish">
                <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
                </div>
                <el-button class="marginLeft10" slot="reference" type="text">删除</el-button>
              </el-popover>
            </div>
            <div v-else-if="scope.row.status === '启用'">
              <el-button type="text primary" @click="handleOption('编辑',scope.row)">编辑</el-button>
              <el-button type="text primary" @click="stop(scope.row)">停用</el-button>
              <el-popover
                placement="top"
                width="172"
                v-model="scope.row.isAbolish">
                <p><i class="el-icon-error" style="color:red;"></i>该操作不可逆,是否确认？</p>
                <div style="text-align: right; margin: 0">
                  <el-button size="mini" type="text" @click="scope.row.isAbolish = false">取消</el-button>
                  <el-button type="primary" size="mini" @click="scope.row.isAbolish = false,del(scope.row.id)">确定</el-button>
                </div>
                <el-button class="marginLeft10" slot="reference" type="text">删除</el-button>
              </el-popover>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination @size-change='handleSizeChange' @current-change='handleCurrentChange' :current-page.sync='PageIndex' :page-sizes='[10, 20, 50]'
                     :page-size='PageSize' layout='total, sizes, prev, pager, next, jumper' :total='total'>
      </el-pagination>
      <!-- 新增菜单对话框 -->
      <el-dialog :title="title" :visible.sync="dialogShow" :before-close="handleClose">
        <el-form :model="addMenuForm" :rules="rules" ref="addMenuForm">
          <el-row :gutter="3">
            <el-col :span="23">
              <el-form-item label="菜单名称:" :label-width="formLabelWidth" prop="menuName">
                <el-input v-model="addMenuForm.menuName" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="菜单级别:" :label-width="formLabelWidth">
                  <el-radio v-model="addMenuForm.menuLevel" label="一级菜单">一级菜单</el-radio>
                  <el-radio v-model="addMenuForm.menuLevel" label="二级菜单">二级菜单</el-radio>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row v-if="addMenuForm.menuLevel==='二级菜单'">
            <el-col :span="12">
              <el-form-item label="父级菜单:" :label-width="formLabelWidth" size="small" prop="TopMenuID">
                <el-select v-model="addMenuForm.topMenuID" placeholder="请选择">
                  <el-option v-for="item in topMenus"
                  :key="item.id"
                  :label="item.menuName"
                  :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3" v-if="addMenuForm.menuLevel==='一级菜单'">
            <el-col :span="23">
              <el-form-item label="菜单路径:" :label-width="formLabelWidth" prop="MenuUrl">
                <el-input v-model="addMenuForm.menuUrl" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3" v-if="addMenuForm.menuLevel==='二级菜单'">
            <el-col :span="23">
              <el-form-item label="菜单路径:" :label-width="formLabelWidth" prop="MenuUrl">
                <el-input v-model="addMenuForm.menuUrl" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="23">
              <el-form-item label="菜单介绍:" :label-width="formLabelWidth" prop="Contents">
                <el-input v-model="addMenuForm.contents" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="3">
            <el-col :span="23">
              <el-form-item label="菜单图标:" :label-width="formLabelWidth" prop="MenuIcon">
                <el-input v-model="addMenuForm.menuIcon" auto-complete="off" size="small" placeholder="请输入"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-row>
            <el-col :span="2" :offset="17">
              <el-button @click="dialogShow = false" size="small">取 消</el-button>
            </el-col>
            <el-col :span="2" :offset="2">
              <el-button type="primary" @click="handleSubmit('addMenuForm')" size="small">确 定</el-button>
            </el-col>
          </el-row>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import isShowButton from '@/mixins'
export default {
  mixins: [isShowButton],
  data() {
    return {
      loading: true,
      isCompleted: false, //是否请求完成
      btnPremissionList: [],
      menuId: this.$route.query.menuId,

      isAbolish:false,
      PageIndex:1, //当前页
      PageSize:10, //每页数量
      totalCache:0, //条数
      title:'',
      status: "",
      statusDatas: [
        {status: "启用",value:1},
        {status: "禁用",value:2},
      ],
      keywords: "",
      topMenus:[], //所有一级菜单
      // 表格
      SystemManage: [],
      // 新增菜单弹出框
      dialogShow: false,
      initForm:{
        ID:'',
        MenuIcon:'', // 图片
        MenuLevel:'', //菜单级别
        MenuName:'', //菜单名
        MenuUrl:'',
        Status:'',
        TopMenuID:'',
        Contents:'' //菜单介绍
      },
      addMenuForm: {},
      formLabelWidth: "100px",

      currentIndex: "",

      // 表单验证规则
      rules: {
        menuName: [{
          required: true, message: "请输入菜单标题", trigger: "blur" }
        ],
        // introduce: [{
        //   required: true, message: "请输入菜单介绍", trigger: "blur" }
        // ],
        menuUrl: [{
          required: true, message: "请输入路径", trigger: "blur"
        }],
        topMenuID: [{
          required: true, message: "请选择父级菜单", trigger: "change"
        }]}
    };
  },
  methods: {
    handleClose(done){
      this.$confirm('关闭后信息不能保存,是否退出？')
        .then(_ => {
          done();
        })
        .catch(_ => {});
    },
    handleSizeChange(val) {
      this.PageSize = val
      this.getDataByCondition()
    },
    handleCurrentChange(val) {
      this.PageIndex = val
      this.getDataByCondition()
    },
    //新增、编辑操作
    handleOption(option,val){
      this.addMenuForm={}
      if(option==='新增'){
        this.title='新增菜单'
        this.addMenuForm=this.initForm
        this.dialogShow=true
      }else if(option==='编辑'){
        this.title = '菜单编辑'
        this.addMenuForm = val
        this.dialogShow=true
      }
    },
    // 重置搜索关键词及状态
    reset() {
      this.keywords = "";
      this.status = "";
      this.getDataByCondition()
    },
    //修改或者添加
    handleSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if(valid) {
          if(this.title==='新增菜单'){
            if(this.addMenuForm.menuLevel==='一级菜单'){
              this.addMenuForm.menuLevel=1
            }else{
              this.addMenuForm.menuLevel=2
            }
            this.addMenuForm.status=1 //1启用,,2禁用
            this.Axios.post('/api/Menu/AddMenu',this.addMenuForm).then(res=>{
              if(res.status === 200){
                this.$message({
                  showClose: true,
                  message: '新增成功',
                  type: 'success'
                });
                this.getDataByCondition()
                this.$refs[formName].resetFields();
              }else{
                this.$message({
                  showClose: true,
                  message: '新增失败',
                  type: 'error'
                });
              }
            })
            this.dialogShow=false
          }else if(this.title==='菜单编辑'){
            if(this.addMenuForm.menuLevel==='一级菜单'){
              this.addMenuForm.menuLevel=1
            }else{
              this.addMenuForm.menuLevel=2
            }
            if(this.addMenuForm.status==='启用'){
              this.addMenuForm.status=1
            }else{
              this.addMenuForm.status=2
            }
            this.Axios.put('/api/Menu/UpdateMenu/'+this.addMenuForm.id,this.addMenuForm).then(res=>{
              if(res.status===200){
                this.$message({
                  showClose: true,
                  message: '修改成功',
                  type: 'success'
                });
                this.getDataByCondition()
                this.$refs[formName].resetFields();
              }else{
                this.$message({
                  showClose: true,
                  message: '编辑失败',
                  type: 'error'
                });
              }
            })

            this.dialogShow=false
          }
        } else {
          return false
        }
      })
    },
    stop(val) {
      this.Axios.put('/api/Menu/UpdateMenuStatus/'+val.id+','+2).then(res=>{
        if(res.status===200){
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
          this.getDataByCondition()
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    operation(val) {
      this.Axios.put('/api/Menu/UpdateMenuStatus/'+val.id+','+1).then(res=>{
        if(res.status===200){
          this.$message({
            showClose: true,
            message: '修改成功',
            type: 'success'
          });
          this.getDataByCondition()
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    // 获取所有菜单
    getAllData(){
      this.Axios.get('/api/Menu/GetAllMenu').then(res=>{
        // console.log('一级菜单', res)
        if(res.status === 200){
          this.topMenus=res.data.data.filter(item=>{
            return item.menuLevel==='一级菜单'
          })
        }
      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    },
    getDataByCondition(){
      const condition={
        start:this.PageIndex,
        pagesize:this.PageSize,
      }
      if(this.status!=''){
        condition.status=this.status
      }
      if(this.keywords!=''){
        condition.keyword=this.keywords
      }
      this.loading = true
      this.Axios.get('/api/Menu/SearchMenu',{params:condition}).then(res=>{
          if(res.status===200){
            this.SystemManage=res.data.data
            this.totalCache=res.data.total
            this.loading = false
          }
      })
    },
    del(id){
      this.Axios.delete('/api/Menu/DeleteMenu/'+id).then((res)=>{
        if(res.data.status){
          this.$message({
            showClose: true,
            message: '删除成功!',
            type: 'success'
          })
          this.getDataByCondition()
        }else{
          this.$message({
            showClose: true,
            message: res.data.Msg,
            type: 'error'
          })
        }

      }).catch(error=>{
        this.$message({
          showClose: true,
          message: '网络错误，联系管理员',
          type: 'error'
        });
      })
    }
  },
  created(){
    this.getBtnRole()
    this.getAllData()
    this.getDataByCondition()
  },
  computed: {
    total() {
      return this.totalCache
    }
  }
};
</script>

<style scoped lang="less">
.remoteConsultation {
  .breadcrumb {
    overflow: hidden;
    span,
    .el-breadcrumb {
      float: left;
    }
    span {
      font-size: 14px;
      color: #666;
      line-height: 1;
    }
  }
  .table-content {
    .tool-bar {
      padding: 0 20px;
      span {
        font-size: 14px;
        color: rgba(0, 0, 0, 0.85);
        font-weight: 400;
      }
      .key-word,
      .status {
        width: 264px;
        margin-right: 40px;
      }
    }
    .el-table {
      margin: 20px 0px;
    }
    .el-pagination {
      /deep/ .number {
        background: #fff;
      }
    }
    .pageSize {
      margin-top: 25px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .consent {
      padding-left: 10px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .el-icon-upload2 {
      font-size: 14px;
      margin-right: 5px;
    }
    .el-icon-download {
      font-size: 20px;
    }
    .el-dialog__wrapper {
      /deep/ .el-dialog__header {
        border-bottom: 1px solid #d9d9d9;
      }
      /deep/ .el-dialog__footer {
        border-top: 1px solid #d9d9d9;
      }
    }
    .el-popover__reference{
      margin-right: 10px;
    }
  }
  .el-dialog__wrapper {
    /deep/ .el-dialog__header {
      border-bottom: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__footer {
      border-top: 1px solid #d9d9d9;
    }
    /deep/ .el-dialog__title {
      font-size: 14px;
    }

    /deep/ .el-dialog{
      width:770px;
    }
    /deep/ .el-input--suffix{
      width: 254px;
    }
    /deep/ .el-textarea__inner{
      width: 620px;
    }
    .uploadBtn {
      margin-right: 10px;
    }
    .consent {
      padding-left: 10px;
    }
    .conditionTextarea {
      width: 70px;
      height: 60px;
      line-height: 24px !important;
      text-align: right;
      margin-right: 8px;
    }
    .el-select {
      width: 224px;
    }
    .el-textarea {
      width: 557px;
    }
  }
  /deep/ .el-form-item.is-required .el-form-item__label:before {
    margin-right: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/SystemSet/SystemManage.vue